// Returns the path to redirect to after login, or '/home' if the value is not a safe in-app path.
// Only same-origin absolute paths are allowed (e.g. "/groups?x=1"); blocks "//host", "/\\host", and "/login" or "/register" loops.
export function getSafeReturnPath(value, fallback = '/home') {
  if (typeof value !== 'string') return fallback;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return fallback;
  // Login and register pages are never a post-login destination (login loops, or register bounces logged-in users)
  if (/^\/(login|register)([?#]|$)/.test(value)) return fallback;
  return value;
}
